import config from '../config';
import Transition from './Transition';

class Preload extends Phaser.Scene {
  init () {
    // console.log('Preload.init');
    let g = this;

    g.sys.game.dataManager.setSessionItem(config.BASE_SCENE, 'Preload');

    // setup assets loaded in boot for branding
    g.add.image(config.CENTER_X, config.CENTER_Y, 'loader-bg');
    g.add.image(config.CENTER_X, 180, 'boot-logo');

    let loaderBar = g.add.graphics();
    g.assets = { loaderBar };
    g.sys.game.sdk.debug('Preload.init');
    // console.log('Preload.init');
  }

  preload () {
    // console.log('Preload.preload');
    let g = this;
    const RES = config.RESOLUTION;
    g.load.path = config.MEDIA_AUDIO_PATH;
    // loops
    g.load.audio('loop-intro', 'loops/intro-loop.mp3');
    g.load.audio('loop-end', 'loops/end-game-loop.mp3');
    g.load.audio('loop-game-1', 'loops/game-loop1.mp3');
    g.load.audio('loop-game-2', 'loops/game-loop2.mp3');
    g.load.audio('loop-game-3', 'loops/game-loop3.mp3');
    // sfx
    g.load.audio('barrier-crystal', 'sfx/barrier-hit/cystal-barrier-hit-converted.mp3');
    g.load.audio('barrier-electric', 'sfx/barrier-hit/electrical-barrier-hit-converted.mp3');
    g.load.audio('barrier-fire', 'sfx/barrier-hit/fire-barrier-hit-converted.mp3');
    g.load.audio('damage', 'sfx/damage/lose-life-converted.mp3');
    g.load.audio('elevator-start', 'sfx/elevator-start/elevator-start-converted.mp3');
    g.load.audio('elevator-stop', 'sfx/elevator-stop/elevator-stop-converted.mp3');
    g.load.audio('play-btn', 'sfx/play-btn/play-btn-converted.mp3');
    g.load.audio('power-up', 'sfx/power-up/power-up-converted.mp3');
    // g.load.audio('cannonbolt-hit', 'sfx/power-up/cannonbolt-hit.mp3');
    g.load.audio('cannonbolt', 'sfx/power-up/cannonbolt.mp3');
    g.load.audio('switch', 'sfx/switch/alien-switch-converted.mp3');
    g.load.audio('time-out', 'sfx/time-out/time-out-converted.mp3');
    g.load.audio('watch-burst', 'sfx/watch-burst/watch-burst3-converted.mp3');
    g.load.audio('jet-boost', 'sfx/wave/jet-boots-converted.mp3');
    // g.load.audio('ben-ah-yeah', 'sfx/ben/ben-ah-yeah.mp3');
    // g.load.audio('ben-not-cool-game-over', 'sfx/ben/ben-not-cool-game-over.mp3');
    // g.load.audio('ben-play', 'sfx/ben-play/ben-hero-time-play-converted.mp3');
    // g.load.audio('ben-replay', 'sfx/ben-replay/ben-replay-converted.mp3');
    g.load.audio('array-ben-hit-1', 'sfx/ben-hits/ben-ah-yeah-converted.mp3');
    g.load.audio('array-ben-hit-2', 'sfx/ben-hits/ben-awesome-converted.mp3');
    g.load.audio('array-ben-hit-3', 'sfx/ben-hits/ben-easy-peasy-converted.mp3');
    // g.load.audio('array-ben-hit-4', 'sfx/ben-hits/ben-I-got-this-converted.mp3');
    g.load.audio('array-ben-hit-5', 'sfx/ben-hits/ben-laugh-converted.mp3');
    g.load.audio('array-ben-hit-6', 'sfx/ben-hits/ben-right-converted.mp3');
    g.load.audio('array-ben-gameover-1', 'sfx/ben-game-over/ben-ah-man-converted.mp3');
    // g.load.audio('array-ben-gameover-2', 'sfx/ben-game-over/ben-but-Im-the-hero-converted.mp3');
    // g.load.audio('array-ben-gameover-3', 'sfx/ben-game-over/ben-not-cool-game-over-converted.mp3');

    g.load.path = config.MEDIA_IMAGE_PATH;

    // NEW OCR A STD FONTS
    g.load.bitmapFont('elevator-door', 'fonts/elevator-door/door-number.png', 'fonts/elevator-door/door-number.xml');
    g.load.bitmapFont('ocr30', 'fonts/ocr-30/ocr-30.png', 'fonts/ocr-30/ocr-30.xml');
    g.load.bitmapFont('ocr20', 'fonts/ocr-20/ocr-20.png', 'fonts/ocr-20/ocr-20.xml');
    g.load.bitmapFont('ocr40', 'fonts/ocr-40/ocr-40.png', 'fonts/ocr-40/ocr-40.xml');
    g.load.bitmapFont('ocr45', 'fonts/ocr-45/ocr-45.png', 'fonts/ocr-45/ocr-45.xml');
    g.load.bitmapFont('ocr50', 'fonts/ocr-50/ocr-50.png', 'fonts/ocr-50/ocr-50.xml');
    g.load.bitmapFont('ocr100', 'fonts/ocr-100/ocr-100.png', 'fonts/ocr-100/ocr-100.xml');

    let lang = g.sys.game.localis.language;
    switch (lang) {
      case 'pt':
      case 'es-419':
      case 'pt-br':
        lang = 'es';
        break;
      case 'da':
        lang = 'no';
        break;
    }

    // BEN 10 ASSETS
    g.load.image('game-logo', 'loader/logo_' + lang + '.png');
    g.load.atlas('ui-animation', 'ui-animation/ui-animation.png', 'ui-animation/ui-animation.json');
    g.load.multiatlas('elevator', 'elevator.json');
    g.load.multiatlas('barriers', 'barriers.json');
    g.load.multiatlas('element-burst', 'element-burst.json');
    g.load.atlas('common', 'common.png', 'common.json');
    g.load.atlas('hero', 'hero.png', 'hero.json');
    g.load.atlas('knight', 'knight.png', 'knight.json');
    g.load.atlas('meter', 'meter.png', 'meter.json');
    g.load.atlas('jets', 'jets.png', 'jets.json');
    g.load.atlas('cannonbolt-trail', 'cannonbolt-trail.png', 'cannonbolt-trail.json');
    g.load.atlas('burst-particles', 'burst-particles.png', 'burst-particles.json');
    g.load.image('transition-bg', 'common/green-bg.jpg');
    g.load.image('overlay-bg', 'common/green-bg-sm.jpg');
    g.load.image('splat', 'common/ad-splat.png');

    // INTRO ASSETS
    g.load.image('intro-bg', 'intro/bg.jpg');
    g.load.atlas('intro', 'intro/intro.png', 'intro/intro.json');

    // end screen
    g.load.image('end-bg', 'end/bg.jpg');
    g.load.image('end-knight', 'end/knight.png');
    g.load.image('end-game-over', 'end/game-over.png');

    // On Individual File Load Complete
    g.load.on('progress', g.onLoadProgress, g);
    // g.load.on('complete', g.onLoadComplete, g);
  }

  onLoadProgress (progress) {
    let { loaderBar } = this.assets;

    let loaderWidth = config.HEIGHT * 0.20;
    let loaderHeight = 12;
    let loaderX = config.CENTER_X - (loaderWidth / 2);
    let loaderY = (config.HEIGHT * 0.91);

    loaderBar.clear();
    // loader outline values
    loaderBar.lineStyle(2, 0x000000);
    // loader bg fill values
    loaderBar.fillStyle(0x14474c);
    loaderBar.fillRoundedRect(loaderX, loaderY, loaderWidth, loaderHeight, 6);
    // loader progress fill values
    loaderBar.fillStyle(0xadf7ff);
    loaderBar.fillRoundedRect(loaderX, loaderY, (loaderWidth * progress), loaderHeight, 6);
    loaderBar.strokeRoundedRect(loaderX, loaderY, loaderWidth, loaderHeight, 6);
  }

  create () {
    // console.log('Preload.create');
    let g = this;
    let frames;

    g.sys.game.sdk.debug('Preload.create');
    // console.log('Preload.create');

    frames = g.anims.generateFrameNames('ui-animation', {
      prefix: 'start-btn_',
      start: 0,
      end: 18,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'play-btn',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    // Intro animation
    frames = g.anims.generateFrameNames('intro', {
      prefix: 'ben-glow/ben-glow_',
      start: 7,
      end: 23,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-ben-glow',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('intro', {
      prefix: 'glow-under/glow-under_',
      start: 7,
      end: 23,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-under-glow',
      frameRate: 12,
      frames: frames,
      repeat: -1,
      showOnStart: true
    });
    frames = g.anims.generateFrameNames('intro', {
      prefix: 'top-glow/omni-top-glow_',
      start: 0,
      end: 23,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-omni',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('intro', {
      prefix: 'burst/burst_',
      start: 7,
      end: 10,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-burst',
      frameRate: 12,
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('intro', {
      prefix: 'arm/arm_',
      start: 5,
      end: 8,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-arm',
      frameRate: 12,
      frames: frames
    });
    // End Intro animations
    frames = g.anims.generateFrameNames('jets');
    g.anims.create({
      key: 'jet-thrust',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('cannonbolt-trail');
    g.anims.create({
      key: 'cannonbolt-trail-animate',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('hero', {
      prefix: 'cannonbolt_',
      start: 0,
      end: 2,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'cannonbolt-spin',
      frameRate: 12,
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('meter', {
      prefix: 'default/green-meter_',
      start: 0,
      end: 29,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'default-meter-fill',
      frameRate: 60,
      frames: frames
    });
    frames = g.anims.generateFrameNames('knight', {
      prefix: 'BoostandGlow/boost-and-glow_',
      start: 0,
      end: 3,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'boost-and-glow',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('knight', {
      prefix: 'EndGameCape/cape_',
      start: 0,
      end: 11,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'end-cape',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('knight', {
      prefix: 'FloorChageCape/cape_',
      start: 0,
      end: 11,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'transition-cape',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });

    frames = g.anims.generateFrameNames('barriers', {
      prefix: 'crystal_',
      start: 0,
      end: 7,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'crystal-barrier-animate',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('barriers', {
      prefix: 'electric_',
      start: 0,
      end: 4,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'electric-barrier-animate',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('barriers', {
      prefix: 'fire_',
      start: 0,
      end: 4,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'fire-barrier-animate',
      frames: frames,
      frameRate: 12,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('element-burst', {
      prefix: 'crystal-burst_',
      start: 0,
      end: 13,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'crystal-burst',
      frames: frames,
      frameRate: 24,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('element-burst', {
      prefix: 'electric-burst_',
      start: 0,
      end: 13,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'electric-burst',
      frames: frames,
      frameRate: 24,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('element-burst', {
      prefix: 'fire-burst_',
      start: 0,
      end: 13,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'fire-burst',
      frames: frames,
      frameRate: 24,
      showOnStart: true,
      hideOnComplete: true
    });
    g.scene.launch('SoundManager');

    let transition = new Transition(g);
    transition.in(() => {
      if (g.sys.game.globalPauseActive) {
        g.deferredIntro = true;
      } else {
        g.scene.start('Intro');
        // g.scene.start('Play');
        // g.scene.start('EndScore');
      }
    });
  }
  update () {
    let g = this;
    if (g.deferredIntro && !g.sys.game.sdkPauseActive) {
      console.log('deferred intro');
      g.deferredIntro = false;
      g.scene.start('Intro');
    }
  }
}

export default Preload;
